var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechPattern5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187.03 152.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-miterlimit:10;stroke-width:0.55px;}.cls-1{stroke:#fff;}.cls-2{stroke:#cfcecd;}.cls-3{fill:#cfcecd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ex_2",
    "data-name": "ex 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101,19.25h0V16.73l2.19-1.26a2.43,2.43,0,0,1,.35,1.26A2.52,2.52,0,0,1,101,19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.53,45.16a2.49,2.49,0,0,1-.29,1.16.6.6,0,0,1-.06.11L101,45.16V42.65h0A2.51,2.51,0,0,1,103.53,45.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101,16.73V45.16L98.83,46.4h0L93,49.79,78.53,58.14l-2,1.17-.11.07-2.24-1.29L53.92,46.43l-2.18-1.27V16.73l2.18-1.26L74.15,3.81l2.22-1.29,2.14,1.23L98.83,15.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2.5 16.73 2.5 45.16 27.12 59.38 51.74 45.16 51.74 16.73 27.12 2.52 2.5 16.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.48,61.85h0V59.31h0l2-1.17L93,49.79l5.86-3.38h0L101,45.16l.11-.07,2.14,1.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "27.24 87.75 27.24 85.15 27.24 61.85 27.24 59.31 27.24 59.3 29.27 58.13 29.28 58.13 49.58 46.4 49.59 46.4 51.74 45.16 51.85 45.09 53.99 46.32 74.2 57.98 76.48 59.3 76.48 59.31 76.48 61.85"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27.07,
    cy: 59.34,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 76.32,
    cy: 59.34,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27.07,
    cy: 2.52,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 76.32,
    cy: 2.52,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27.07,
    cy: 87.66,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2.52,
    cy: 45.17,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2.52,
    cy: 16.73,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 51.76,
    cy: 45.17,
    r: 2.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 51.76,
    cy: 16.73,
    r: 2.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.53,45.16a2.49,2.49,0,0,1-.29,1.16.6.6,0,0,1-.06.11,2.51,2.51,0,0,1-4.35,0h0a2.41,2.41,0,0,1-.34-1.24,2.52,2.52,0,0,1,2.5-2.51h0A2.51,2.51,0,0,1,103.53,45.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.53,16.73A2.52,2.52,0,0,1,101,19.25h0a2.53,2.53,0,0,1-2.5-2.52,2.41,2.41,0,0,1,.34-1.25,2.5,2.5,0,0,1,4.35,0A2.43,2.43,0,0,1,103.53,16.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.87 80.26 111.87 108.23 136.1 122.22 160.32 108.23 160.32 80.26 136.1 66.27 111.87 80.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "184.55 122.22 182.4 120.98 162.48 109.48 160.32 108.23 160.32 108.22 160.32 105.76 160.32 82.73 160.32 80.26 162.48 79.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "184.66 122.15 160.43 108.16 136.21 122.15 136.21 150.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "136.21 150.12 136.21 122.15 111.98 108.16"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 136.11,
    cy: 122.18,
    r: 2.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 136.11,
    cy: 66.27,
    r: 2.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 184.56,
    cy: 122.18,
    r: 2.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 136.11,
    cy: 150.04,
    r: 2.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 111.89,
    cy: 108.23,
    r: 2.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 111.89,
    cy: 80.26,
    r: 2.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 160.34,
    cy: 108.23,
    r: 2.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 160.34,
    cy: 80.26,
    r: 2.47
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechPattern5);
export default __webpack_public_path__ + "static/media/tech-pattern-5.3e1d94fb264c996843787b28b302ad71.svg";
export { ForwardRef as ReactComponent };